import { createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import {
  canRegisterWithCustomerId,
  register,
  registerPasswordResetInitiatedEvent,
  registerAccountCreationInitiatedEvent,
} from '../services/UserAccountsPublicService';

export const useUserAccountsPublicCanRegisterWithCustomerId = createMutationHook(
  collapseDataFromCall(
    collapseParams(collapseParams(canRegisterWithCustomerId, 'requestBody', 'data'), 'data', 'address', 'surname'),
  ),
  {
    injectables: ['label', 'customerId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['address', 'surname'] },
    ],
  },
);

export const useUserAccountsPublicRegister = createMutationHook(
  collapseParams(
    collapseParams(register, 'requestBody', 'data'),
    'data',
    'emailAddress',
    'password',
    'primaryEmailOverride',
    'source',
    'address',
    'surname',
  ),
  {
    injectables: ['label', 'customerId', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['emailAddress', 'password', 'primaryEmailOverride', 'source', 'address', 'surname'] },
    ],
  },
);

export const useUserAccountsPublicRegisterPasswordResetInitiatedEvent = createMutationHook(
  collapseParams(collapseParams(registerPasswordResetInitiatedEvent, 'requestBody', 'data'), 'data', 'address'),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['address'] },
    ],
  },
);

export const useUserAccountsPublicRegisterAccountCreationInitiatedEvent = createMutationHook(
  collapseParams(collapseParams(registerAccountCreationInitiatedEvent, 'requestBody', 'data'), 'data', 'address'),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['address'] },
    ],
  },
);
